import styled, { FlattenSimpleInterpolation } from 'styled-components';
import tw from 'tailwind.macro';
import {
  FUNNEL_NAVIGATION_LEFT_BUTTON,
  FUNNEL_NAVIGATION_RIGHT_BUTTON,
} from '../constants';

const Wrapper = styled.div<{ customStyle?: FlattenSimpleInterpolation }>`
  ${tw`w-full py-medium px-medium2 flex justify-between`}
  gap:var(--size-medium);
  min-height: 80px;

  ${({ customStyle }) => customStyle}
`;

const Button = styled.button<{ customStyle?: FlattenSimpleInterpolation }>`
  ${({ customStyle }) => customStyle}
`;

type FunnelNavigationProps = {
  onLeftButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  leftButtonIcon?: React.ReactNode;
  leftButtonId?: string;
  leftButtonCustomStyle?: FlattenSimpleInterpolation;
  onRightButtonClick?: () => void;
  rightButtonIcon?: React.ReactNode;
  rightButtonId?: string;
  rightButtonCustomStyle?: FlattenSimpleInterpolation;
  Container: React.FunctionComponent;
  children?: React.ReactNode;
  customStyle?: FlattenSimpleInterpolation;
  footer?: React.ReactNode;
};

/**
 * @description Returns the navigation bar used on funnel pages.
 * @returns {JSX.Element}
 */
const FunnelNavigation = ({
  children,
  Container,
  customStyle,
  footer,
  leftButtonCustomStyle,
  leftButtonIcon,
  leftButtonId,
  onLeftButtonClick,
  onRightButtonClick,
  rightButtonCustomStyle,
  rightButtonIcon,
  rightButtonId,
}: FunnelNavigationProps) => (
  <Container>
    <Wrapper customStyle={customStyle}>
      {leftButtonIcon && (
        <Button
          customStyle={leftButtonCustomStyle}
          data-testid={FUNNEL_NAVIGATION_LEFT_BUTTON}
          id={leftButtonId}
          onClick={onLeftButtonClick}
        >
          {leftButtonIcon}
        </Button>
      )}

      {children}

      {rightButtonIcon && (
        <Button
          customStyle={rightButtonCustomStyle}
          data-testid={FUNNEL_NAVIGATION_RIGHT_BUTTON}
          id={rightButtonId}
          onClick={onRightButtonClick}
        >
          {rightButtonIcon}
        </Button>
      )}
    </Wrapper>

    {footer}
  </Container>
);

export default FunnelNavigation;
